module.exports = __webpack_public_path__ + "static/media/1-3.a71cb6e6.png";